import { useState, useEffect } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';

export const useGuidedTour = (teamId) => {
  const [showTour, setShowTour] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkTourStatus = async () => {
      const user = auth?.currentUser;
      if (!user || !teamId) {
        setIsLoading(false);
        return;
      }

      try {
        const userRef = doc(db, `users/${user.uid}`);
        const userSnap = await getDoc(userRef);
        
        if (userSnap.exists()) {
          const userData = userSnap.data();
          // Show tour if user hasn't completed it and has a team
          const hasCompletedTour = userData.hasCompletedTour === true;
          
          if (!hasCompletedTour && teamId) {
            // Small delay to ensure page is fully loaded
            setTimeout(() => {
              setShowTour(true);
            }, 1000);
          }
        }
      } catch (err) {
        console.error('Failed to check tour status', err);
      } finally {
        setIsLoading(false);
      }
    };

    checkTourStatus();
  }, [teamId]);

  const completeTour = async () => {
    const user = auth?.currentUser;
    if (!user) return;

    try {
      const userRef = doc(db, `users/${user.uid}`);
      await updateDoc(userRef, {
        hasCompletedTour: true,
        tourCompletedAt: new Date().toISOString(),
      });
      setShowTour(false);
    } catch (err) {
      console.error('Failed to mark tour as complete', err);
    }
  };

  const skipTour = async () => {
    await completeTour();
  };

  const startTour = () => {
    setShowTour(true);
  };

  return {
    showTour,
    isLoading,
    completeTour,
    skipTour,
    startTour,
  };
};

